var map = {
	"./fullscreen/open/pc/btn_speaker_off.png": "0d8c",
	"./fullscreen/open/pc/btn_speaker_on.png": "2f99",
	"./window/open/pc/btn_speaker_off.png": "8ca9",
	"./window/open/pc/btn_speaker_on.png": "4285"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1808";